// extracted by mini-css-extract-plugin
export var active = "_91-7";
export var container = "_91-0";
export var evenWidth = "_91-4";
export var large = "_91-5";
export var outlet = "_91-8";
export var slide = "_91-2";
export var small = "_91-6";
export var tab = "_91-3";
export var tabs = "_91-1";